import React, { useEffect, useState, useRef } from "react";
const CarruselImagenes = ({
    imagenes = [],
    titulo = "",
    descripcion = "",
  }) => {
  
    const [indiceActual, setIndiceActual] = useState(0);
    const [fade, setFade] = useState(true);
    const [hovered, setHovered] = useState(false);
    const [pausado, setPausado] = useState(false);
  
    const siguienteImagen = () => {
      setFade(false);
      setTimeout(() => {
        setIndiceActual((prev) => (prev + 1) % imagenes.length);
        setFade(true);
      }, 300);
    };
  
    const anteriorImagen = () => {
      setFade(false);
      setTimeout(() => {
        setIndiceActual(
          (prev) => (prev - 1 + imagenes.length) % imagenes.length
        );
        setFade(true);
      }, 300);
    };
  
    const irAImagen = (index) => {
      setFade(false);
      setTimeout(() => {
        setIndiceActual(index);
        setFade(true);
      }, 300);
    };
  
    const alternarPausa = () => setPausado(!pausado);
  
    useEffect(() => {
      if (!pausado) {
        const interval = setInterval(() => {
          siguienteImagen();
        }, 4000);
        return () => clearInterval(interval);
      }
    }, [pausado, indiceActual]);
  
    const botonNav = (side) => ({
      position: "absolute",
      top: "50%",
      [side]: "10px",
      transform: "translateY(-50%)",
      background: "rgba(0,0,0,0.5)",
      color: "#fff",
      border: "none",
      borderRadius: "50%",
      width: "35px",
      height: "35px",
      cursor: "pointer",
      fontSize: "18px",
      backdropFilter: "blur(4px)",
    });
  
    return (
      <div
        style={{
          position: "relative",
          width: "95%",
          maxWidth: "900px",
          margin: "auto",
          marginTop: "15px",
          overflow: "hidden",
          borderRadius: "18px",
          boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
          background: "#000",
        }}
      >
        {/* Imagen */}
        <img
          src={imagenes[indiceActual]}
          alt={`slide-${indiceActual}`}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          style={{
            width: "100%",
            height: "380px",
            objectFit: "cover",
            opacity: fade ? 1 : 0,
            transform: hovered
              ? "scale(1.03)"
              : fade
              ? "scale(1)"
              : "scale(1.02)",
            transition: "opacity 0.5s ease, transform 0.5s ease",
            display: "block",
          }}
        />
  
        {/* OVERLAY */}
        <div
          style={{
            position: "absolute",
            bottom: "0",
            width: "100%",
            padding: "18px",
            background: "rgba(0,0,0,0.60)",
            backdropFilter: "blur(4px)",
          }}
        >
          {/* TÍTULO dinámico */}
          <div
            style={{
              fontWeight: "bold",
              fontSize: "20px",
              color: "#fff",
              marginBottom: "6px",
            }}
          >
            {titulo}
          </div>
  
          {/* DESCRIPCIÓN dinámica */}
          <div
            style={{
              fontSize: "13px",
              lineHeight: "1.4",
              color: "#fff",
              fontWeight: 500,
              opacity: 0.9,
              marginBottom:"28px"
            }}
          >
            {descripcion}
          </div>
        </div>
  
        {/* Botón anterior */}
        <button onClick={anteriorImagen} style={botonNav("left")}>
          ◀
        </button>
  
        {/* Botón siguiente */}
        <button onClick={siguienteImagen} style={botonNav("right")}>
          ▶
        </button>
  
        {/* Puntos + Pausa */}
        <div
          style={{
            position: "absolute",
            bottom: "12px",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            gap: "10px",
            alignItems: "center",
          }}
        >
          {imagenes.map((_, index) => (
            <span
              key={index}
              onClick={() => irAImagen(index)}
              style={{
                width: "11px",
                height: "11px",
                borderRadius: "50%",
                cursor: "pointer",
                backgroundColor:
                  index === indiceActual ? "#fff" : "rgba(255,255,255,0.4)",
                border: "1px solid rgba(255,255,255,0.6)",
                transform: index === indiceActual ? "scale(1.2)" : "scale(1)",
                transition: "0.25s",
              }}
            />
          ))}
  
          {/* Botón pausa */}
          <button
            onClick={alternarPausa}
            style={{
              background: "rgba(0,0,0,0.5)",
              color: "#fff",
              border: "none",
              borderRadius: "50%",
              padding: "5px 8px",
              cursor: "pointer",
              fontSize: "13px",
              backdropFilter: "blur(4px)",
              marginLeft: "10px",
            }}
          >
            {pausado ? "▶" : "⏸"}
          </button>
        </div>
      </div>
    );
  };
  
export default CarruselImagenes;
